var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.recommendedProducts.length > 0 ? "VueSlickCarousel" : "div",
    _vm._b(
      {
        ref: "productrecommendations",
        tag: "div",
        staticClass: "product-recommendations"
      },
      "div",
      _vm.sliderSettings,
      false
    ),
    _vm._l(_vm.recommendedProducts, function(product) {
      return _c(
        "div",
        {
          on: {
            click: function($event) {
              return _vm.navigate(product.url, $event)
            }
          }
        },
        [
          _c("product-tile", {
            key: product.id,
            attrs: {
              product: product,
              "tile-color": _vm.tileColor,
              "no-link": ""
            }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }